import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import InputTextComponent from '../../../../partials/form/fields/InputTextComponent';
import PasswordComponent from '../../../../partials/form/fields/PasswordComponent';
import DropdownComponent from '../../../../partials/form/fields/DropdownComponent';
import InputSwitchComponent from '../../../../partials/form/fields/InputSwitchComponent';
import InputTextareaComponent from '../../../../partials/form/fields/InputTextareaComponent';
import ApiService from '../../../../service/ApiService';

const AddNewUser = (props) => {
    const [performValidation, setPerformValidation] = useState(false);
    const [formData, setFormData] = useState({
        clientId: props.clientId,
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        privilegeLevel: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        userIsLockedOut: false,
        lockoutText: '',
        maxUploadCount: '',
        uploadCount: '',
        enabled: false
    });

    const [formErrors, setFormErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        privilegeLevel: '',
        password: '',
        confirmPassword: ''
    });

    useEffect(() => {
        if (props.userId) {
            const apiService = new ApiService();
            apiService.getUser(props.userId).then((data) => {
                setFormData(data);
            });
        }
    }, [props.userId]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setPerformValidation(true);
        if (validateForm()) {
            props.handleAddUser(formData);
        }
    };

    useEffect(() => {
        if (performValidation) {
            validateForm();
        }
    }, [performValidation, formData]);

    const validateForm = () => {
        let isValid = true;
        const errors = {
            firstName: '',
            lastName: '',
            email: '',
            privilegeLevel: '',
            password: '',
            confirmPassword: ''
        };

        if (!formData.firstName || formData.firstName.trim() === '') {
            isValid = false;
            errors.firstName = 'First Name is required';
        }
        if (!formData.lastName || formData.lastName.trim() === '') {
            isValid = false;
            errors.lastName = 'Last Name is required';
        }
        if (!formData.email || formData.email.trim() === '') {
            isValid = false;
            errors.email = 'Email is required';
        }
        if (!props.userId && (!formData.password || formData.password.trim() === '')) {
            isValid = false;
            errors.password = 'Password is required';
        }
        if (formData.password && formData.password.trim() !== '' && (!formData.confirmPassword || formData.confirmPassword.trim() === '')) {
            isValid = false;
            errors.confirmPassword = 'Confirm Password is required';
        }
        if (formData.password !== formData.confirmPassword) {
            isValid = false;
            errors.password = 'Passwords do not match';
            errors.confirmPassword = 'Passwords do not match';
        }

        setFormErrors(errors);
        return isValid;
    };

    const privLevels = [
        { name: 'None', code: '' },
        { name: 'Global Admin', code: 'GLOBAL_ADMIN' }
    ];

    const inputChanged = (value, field) => {
        var d = { ...formData };
        d[field] = value;
        setFormData(d);
    };

    return (
        <>
            <form onSubmit={handleSubmit} className="p-fluid custom-form">
                <h6>User Details</h6>
                <hr />
                <InputTextComponent
                    id="firstName"
                    value={formData.firstName}
                    onChange={(value) => inputChanged(value, "firstName")}
                    aria-describedby="firstName-help"
                    className={formErrors.firstName ? "p-invalid block" : "block"}
                    required
                />
                {formErrors.firstName && <small id="firstName-help" className="p-error block">{formErrors.firstName}</small>}

                <InputTextComponent
                    id="lastName"
                    value={formData.lastName}
                    onChange={(value) => inputChanged(value, "lastName")}
                    aria-describedby="lastName-help"
                    className={formErrors.lastName ? "p-invalid block" : "block"}
                    required
                />
                {formErrors.lastName && <small id="lastName-help" className="p-error block">{formErrors.lastName}</small>}

                <InputTextComponent
                    id="email"
                    value={formData.email}
                    onChange={(value) => inputChanged(value, "email")}
                    aria-describedby="email-help"
                    className={formErrors.email ? "p-invalid block" : "block"}
                    required
                />
                {formErrors.email && <small id="email-help" className="p-error block">{formErrors.email}</small>}

                <PasswordComponent
                    id="password"
                    value={formData.password}
                    onChange={(value) => inputChanged(value, "password")}
                    passwordRequired={true}
                    formErrors={formErrors}
                    autoComplete="new-password"
                />

                <PasswordComponent
                    id="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={(value) => inputChanged(value, "confirmPassword")}
                    passwordRequired={true}
                    formErrors={formErrors}
                    autoComplete="new-password"
                />

                <DropdownComponent
                    id="privilegeLevel"
                    value={formData.privilegeLevel}
                    options={privLevels}
                    onChange={(value) => inputChanged(value, "privilegeLevel")}
                    aria-describedby="privilegeLevel-help"
                    className={formErrors.privilegeLevel ? "p-invalid" : ""}
                />

                {formErrors.privilegeLevel && <small id="privilegeLevel-help" className="p-error block">{formErrors.privilegeLevel}</small>}

                <InputSwitchComponent
                    id="userIsLockedOut"
                    checked={formData.userIsLockedOut}
                    onChange={(value) => inputChanged(value, "userIsLockedOut")}
                    aria-describedby="userIsLockedOut-help"
                />

                <InputTextareaComponent
                    id="lockoutText"
                    value={formData.lockoutText}
                    onChange={(value) => inputChanged(value, "lockoutText")}
                    aria-describedby="lockoutText-help"
                    className="block"
                />

                <InputTextComponent
                    id="maxUploadCount"
                    value={formData.maxUploadCount}
                    onChange={(value) => inputChanged(value, "maxUploadCount")}
                    aria-describedby="maxUploadCount-help"
                    className="block"
                />

                <InputTextComponent
                    id="uploadCount"
                    value={formData.uploadCount}
                    onChange={(value) => inputChanged(value, "uploadCount")}
                    aria-describedby="uploadCount-help"
                    className="block"
                />

                <InputSwitchComponent
                    id="enabled"
                    checked={formData.enabled}
                    onChange={(value) => inputChanged(value, "enabled")}
                    aria-describedby="enabled-help"
                />

                <div className="field grid">
                    <div className="col-fixed" style={{ width: '150px' }}></div>
                    <div className="input" style={{ flex: '1' }}>
                        <Button type="submit" label="Submit" className="mt-2 mb-2 btn-custom" style={{ width: '150px', float: 'right' }} />
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddNewUser;
